import React, { Component } from 'react';
import PropTypes from "prop-types";
import { async } from 'q';


class AppViewContainer extends Component {

    static contextTypes = {
        router: PropTypes.object,
    };


    constructor(props) {
        super();
        this.state = {

        }
    }

    componentDidMount = async ()=> {
        await this.props.setGeneralData();
    }
  
    componentWillMount = async () => { 
        await this.props.setAllLanguages(); 
        if(this.props.token!==""){
            await this.props.validateusertoken(this.props.token); 
        }else{         
                this.props.history.push(`/login`);         
        }
        
        
    }

   
    shouldComponentUpdate(nextProps, nextState) {
        if (this.props.isLoading_auth == true && nextProps.isLoading_auth == false) {
            if (nextProps.isAuthenticated === false) {
                this.props.history.push(`/login`);
            }
        }else if (nextProps.isAuthenticated === false) {
           this.props.history.push(`/login`);
        }
        return true;
    }





    render() {
        return (
            <React.Fragment>
                {this.props.children}
            </React.Fragment>
        );
    }


}


/* Export Component ==================================================================== */
export default AppViewContainer;